import { Copy } from "lucide-react";
import { toast } from "sonner";

export const CopyBlock = ({ value, testId, pre }) => (
  <div className="pp-copyblock" data-testid={testId}>
    {pre ? <pre>{value}</pre> : <code>{value}</code>}
    <button
      className="pp-icon"
      data-testid={`${testId}-copy`}
      aria-label="Copy"
      onClick={() => navigator.clipboard?.writeText(value).then(() => toast.success("Copied"))}
    >
      <Copy className="h-4 w-4" />
    </button>
  </div>
);
